// @ts-strict-ignore
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CustomStepDefinition, Options } from '@angular-slider/ngx-slider';
import { ArrayUtils } from '../util/array-utils';
import { NumberUtils } from '../util/number-utils';

@Component({
  standalone: false,
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit, OnChanges {

  @Input() public value: number;
  @Input() public highValue: number;
  @Input() public stepsArray: number[];
  @Input() public width: number;
  @Input() public stepWidth: number = 10;

  @Output() public valueChangedEmitter: EventEmitter<number> = new EventEmitter();

  public options: Options = {
    showTicks: true,
  };

  ngOnInit(): void {
    this.setStepsArrayOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.stepsArray && !changes.stepsArray.isFirstChange()) {
      if (ArrayUtils.isNotEmpty(this.stepsArray)) {
        const newOptions: Options = Object.assign({}, this.options);
        newOptions.stepsArray = this.createCustomStepsDefinition();
        newOptions.customValueToPosition = this.customValueIndexToPosition.bind(this);
        newOptions.customPositionToValue = this.customPositionToValueIndex.bind(this);
        this.options = newOptions;
      }
    }
  }

  private setStepsArrayOptions(): void {
    this.stepsArray.sort((a: number, b: number) => NumberUtils.numericCompare(a, b));
    this.options.stepsArray = this.createCustomStepsDefinition();
    this.options.enforceStepsArray = true;
    this.options.customValueToPosition = this.customValueIndexToPosition.bind(this);
    this.options.customPositionToValue = this.customPositionToValueIndex.bind(this);
  }

  private createCustomStepsDefinition(): CustomStepDefinition[] {
    return this.stepsArray.map((value: number, index: number, array: number[]) => {
      return {
        value: value,
        legend: index == 0 || index == array.length - 1 || value % this.stepWidth == 0 ? value.toString() : undefined,
      };
    });
  }

  private customValueIndexToPosition(valueIndex: number): number {
    return (this.stepsArray[valueIndex] - this.stepsArray[0]) / this.getStepsArrayRange();
  }

  private customPositionToValueIndex(percent: number): number {
    const value: number = percent * this.getStepsArrayRange() + this.stepsArray[0];
    const closestValue: number = this.stepsArray.reduce((prev: number, curr: number) => {
      return (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
    });
    return this.stepsArray.indexOf(closestValue);
  }

  private getStepsArrayRange(): number {
    const minValue: number = this.stepsArray[0];
    const maxValue: number = this.stepsArray[this.stepsArray.length - 1];
    return maxValue - minValue;
  }

  public onValueChange(): void {
    this.valueChangedEmitter.emit(this.value);
  }
}
